import { Avatar, Box, IconButton, Tooltip, Typography } from "@mui/material";
import {
  ContributorsContainer,
  GenresAndContributorsContainer,
  GenresDetailsContainer,
  MessageContainer,
  CollaboratorsStyles,
} from "../styles";
import { useNavigate } from "react-router-dom";
import MessageIcon from "@mui/icons-material/Message";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { CollaboratorsProps } from "../types";
import { isMobile } from "react-device-detect";
import { TEXT_COLOR } from "../../../theme";

export const Collaborators: React.FC<CollaboratorsProps> = ({
  genres,
  expand,
  contributors,
  bpm,
  handleOpenCollabsModal,
  id,
  loaded,
  handleCreateGroupChat,
  trackTitle,
  isTrackConnectedToTutorial,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <Box>
        <Box>
          <GenresAndContributorsContainer>
            <GenresDetailsContainer>
              <Box style={{ display: "flex", flexDirection: "column" }}>
                {bpm !== undefined && bpm !== 0 && (
                  <Typography noWrap sx={CollaboratorsStyles.genreText}>
                    <span style={CollaboratorsStyles.genreLabel}>BPM: </span>
                    {bpm}
                  </Typography>
                )}

                <Typography noWrap sx={CollaboratorsStyles.genreText}>
                  <span style={CollaboratorsStyles.genreLabel}>Genre: </span>{" "}
                  {genres && genres}
                  {!genres && "Unknown"}
                </Typography>
              </Box>
            </GenresDetailsContainer>

            <ContributorsContainer max={expand ? undefined : isMobile ? 2 : 5}>
              {contributors &&
                contributors
                  .filter((c: any) => c.getUsername())
                  .map((contributor: any) => {
                    return (
                      <Tooltip
                        key={contributor.getUsername()}
                        title={contributor.getUsername()}
                        placement="top"
                      >
                        <Avatar
                          style={CollaboratorsStyles.contributorsPhotos}
                          src={
                            contributor.getProfilePicture()
                              ? contributor.getProfilePicture()
                              : "/broken-image.jpg"
                          }
                          onClickCapture={() => {
                            navigate(
                              `/user-profile/${contributor.getUsername()}`
                            );
                          }}
                          alt={contributor.getUsername()}
                        />
                      </Tooltip>
                    );
                  })}
            </ContributorsContainer>
            <MessageContainer>
              {handleOpenCollabsModal && (
                <Tooltip title="Add Collaborators">
                  <IconButton
                    id={isTrackConnectedToTutorial ? "step-19" : ""}
                    size="small"
                    sx={{ marginLeft: 1 }}
                    onClickCapture={(e) => {
                      e.stopPropagation();
                      if (handleOpenCollabsModal) handleOpenCollabsModal(id!);
                    }}
                  >
                    <ManageAccountsIcon
                      sx={{
                        ...CollaboratorsStyles.playbackIcons,
                        ...{ color: TEXT_COLOR },
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip title="Go to track chat">
                <IconButton
                  id={isTrackConnectedToTutorial ? "step-20" : ""}
                  sx={{ color: TEXT_COLOR }}
                  aria-label="edit"
                  onClickCapture={(e) => {
                    e.stopPropagation();
                    handleCreateGroupChat(id, trackTitle);
                  }}
                >
                  <MessageIcon />
                </IconButton>
              </Tooltip>
            </MessageContainer>
          </GenresAndContributorsContainer>
        </Box>
      </Box>
    </>
  );
};
